exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Ubuntu:wght@300;400&display=swap);", ""]);

// module
exports.push([module.id, "html{position:relative;min-height:100%}body,html{background-color:#000}body{font-family:Ubuntu,sans-serif;color:#bbb;margin-bottom:60px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5e0de8ba","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 13
// module chunks = 0